// src/belediye/components/utils/Pagination.js
//
// PAYLAŞILAN sayfalama — tek kaynak, her sayfada AYNI mantık + görünüm.
// Başvurular sayfasındaki sayfalama birebir buraya taşındı:
//   • Sonuç özeti ("X sonuç · a–b arası gösteriliyor")
//   • Önceki / numaralar (ellipsis'li) / Sonraki
//   • 1..7 arası tüm sayfalar; fazlası ellipsis ile kısaltılır
//
// Kullanım:
//   <Pagination
//     page={page}
//     totalCount={count}
//     pageSize={50}
//     shownCount={items.length}   // (opsiyonel) bu sayfada görünen kayıt sayısı
//     onChange={setPage}
//   />

import React, { useMemo } from "react";

import "./Pagination.css";

export function buildPaginationItems(page, total) {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const items = [1];
  if (page > 4) items.push("left-ellipsis");
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  for (let i = start; i <= end; i += 1) items.push(i);
  if (page < total - 3) items.push("right-ellipsis");
  items.push(total);
  return items;
}

export default function Pagination({
  page,
  totalCount = 0,
  pageSize = 50,
  shownCount,
  onChange,
}) {
  const count = totalCount || 0;
  const size = pageSize > 0 ? pageSize : 50;
  const totalPages = Math.max(1, Math.ceil(count / size));

  const items = useMemo(
    () => buildPaginationItems(page, totalPages),
    [page, totalPages]
  );

  const startIndex = (page - 1) * size;
  const shown =
    typeof shownCount === "number"
      ? shownCount
      : Math.max(0, Math.min(size, count - startIndex));
  const shownFrom = count === 0 ? 0 : startIndex + 1;
  const shownTo = startIndex + shown;

  const go = (p) => {
    if (typeof onChange === "function") onChange(p);
  };

  return (
    <div className="ui-pagination-bar">
      <div className="ui-pagination-summary">
        {count > 0 ? (
          <>
            <strong>{count}</strong> sonuç · {shownFrom}–{shownTo} arası
            gösteriliyor
          </>
        ) : (
          "Sonuç yok"
        )}
      </div>

      {totalPages > 1 && (
        <div className="ui-pagination" aria-label="Sayfalama">
          <button
            type="button"
            className="ui-pagination-nav"
            disabled={page === 1}
            onClick={() => go(Math.max(1, page - 1))}
          >
            Önceki
          </button>

          {items.map((item, idx) => {
            if (typeof item === "string" && item.includes("ellipsis")) {
              return (
                <span
                  key={`${item}-${idx}`}
                  className="ui-pagination-ellipsis"
                >
                  …
                </span>
              );
            }
            return (
              <button
                type="button"
                key={item}
                className={item === page ? "active" : ""}
                onClick={() => go(item)}
              >
                {item}
              </button>
            );
          })}

          <button
            type="button"
            className="ui-pagination-nav"
            disabled={page === totalPages}
            onClick={() => go(Math.min(totalPages, page + 1))}
          >
            Sonraki
          </button>
        </div>
      )}
    </div>
  );
}
